var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "separable" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "pesquisa",
            {
              attrs: {
                hasPesquisaAvancada: true,
                placeHolder: _vm.placeholderPesquisaSimples
              },
              on: {
                search: _vm.pesquisarSimples,
                searchAdvanced: _vm.pesquisarAvancado
              }
            },
            [
              _c("template", { slot: "pesquisaAvancada" }, [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.$emit(
                          "search",
                          _vm.searchObject.simpleFieldValue
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "panel positionInput" },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("p", { staticClass: "titulo" }, [
                                  _vm._v("Processo:")
                                ]),
                                _c("el-input", {
                                  attrs: { maxlength: "25" },
                                  on: {
                                    input: function($event) {
                                      return _vm.$emit(
                                        "advancedInput",
                                        _vm.searchObject.advancedObject
                                      )
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.searchObject.advancedObject
                                        .numeroProcesso,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchObject.advancedObject,
                                        "numeroProcesso",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "searchObject.advancedObject.numeroProcesso"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("p", { staticClass: "titulo" }, [
                                  _vm._v("CPF/CNPJ do interessado:")
                                ]),
                                _c("el-input", {
                                  directives: [
                                    {
                                      name: "mask",
                                      rawName: "v-mask",
                                      value: [
                                        "###.###.###-##",
                                        "##.###.###/####-##"
                                      ],
                                      expression:
                                        "['###.###.###-##', '##.###.###/####-##']"
                                    }
                                  ],
                                  staticClass: "input-with-select",
                                  on: {
                                    input: function($event) {
                                      return _vm.$emit(
                                        "advancedInput",
                                        _vm.searchObject.advancedObject
                                      )
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.searchObject.advancedObject.cpfCnpj,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchObject.advancedObject,
                                        "cpfCnpj",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "searchObject.advancedObject.cpfCnpj"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { staticClass: "margin-top", attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("p", { staticClass: "titulo" }, [
                                  _vm._v("Nome/Razão social do interessado:")
                                ]),
                                _c("el-input", {
                                  on: {
                                    input: function($event) {
                                      return _vm.$emit(
                                        "advancedInput",
                                        _vm.searchObject.advancedObject
                                      )
                                    }
                                  },
                                  model: {
                                    value:
                                      _vm.searchObject.advancedObject
                                        .nomeRazaoSocial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchObject.advancedObject,
                                        "nomeRazaoSocial",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "searchObject.advancedObject.nomeRazaoSocial"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("p", { staticClass: "titulo" }, [
                                  _vm._v("Tipo de processo:")
                                ]),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      placeholder: "Selecione",
                                      clearable: "clearable"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.$emit(
                                          "advancedInput",
                                          _vm.searchObject.advancedObject
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.searchObject.advancedObject.tipo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.searchObject.advancedObject,
                                          "tipo",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "searchObject.advancedObject.tipo"
                                    }
                                  },
                                  _vm._l(_vm.tipoProcessosFiltrados, function(
                                    tipo
                                  ) {
                                    return _c("el-option", {
                                      key: tipo.codigo,
                                      staticClass: "label-option",
                                      attrs: {
                                        label: tipo.nome,
                                        value: tipo.codigo
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _c(
        "app-listagem",
        {
          attrs: {
            tituloCard: _vm.tituloCard,
            hasActionButton: true,
            sizeActionButton: _vm.sizeActionButton,
            nameActionButton: _vm.nameActionButton,
            hasHeaderAndRefreshButton: true,
            headerLabel: _vm.headerLabel,
            dataForTable: _vm.processosFisicos,
            totalElements: _vm.totalProcessos,
            pagina: _vm.pagina
          },
          on: {
            changePage: _vm.changePage,
            updateListagem: _vm.updateListagem,
            click: _vm.criarProcessoFisico
          }
        },
        [
          _c(
            "template",
            { slot: "columns" },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "numeroProcesso",
                  width: "auto",
                  label: "Processo"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "CPF/CNPJ do interessado",
                  width: "auto",
                  prop: "cpfCnpj"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Nome/Razão social do interessado",
                  prop: "nomeRazaoSocial",
                  "min-width": "155",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tipo de processo",
                  prop: "tipo",
                  "min-width": "100",
                  sortable: "sortable"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", width: "105" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click", size: "small" } },
                          [
                            _c(
                              "el-button",
                              { attrs: { type: "primary", size: "mini" } },
                              [
                                _vm._v("Ações  "),
                                _c("i", { staticClass: "fal fa-chevron-down" })
                              ]
                            ),
                            _vm.isPa
                              ? _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    scope.row.isFinalizado
                                      ? _c("el-dropdown-item", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex",
                                              on: {
                                                click: function($event) {
                                                  return _vm.visualizarProcesso(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "far fa-cogs"
                                              }),
                                              _vm._v("  Gerenciar processo")
                                            ]
                                          )
                                        ])
                                      : _c("el-dropdown-item", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "flex",
                                              on: {
                                                click: function($event) {
                                                  return _vm.visualizarProcesso(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "far fa-file"
                                              }),
                                              _vm._v("  Continuar cadastro")
                                            ]
                                          )
                                        ])
                                  ],
                                  1
                                )
                              : _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c("el-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex",
                                          on: {
                                            click: function($event) {
                                              return _vm.visualizarProcesso(
                                                scope.row.numeroProcesso
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fal fa-cogs"
                                          }),
                                          _vm._v("  Gerenciar processo")
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78cbdb4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78cbdb4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/processoFisico/ListagemProcessoFisico.vue
// module id = null
// module chunks = 